import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";

import { RouterProvider } from "react-router-dom";
import { Providers } from "./store/providers.tsx";
import "./index.scss";
import router, { microConfig } from "./router/router.tsx";
import microApp from "@micro-zoe/micro-app";
import { useDispatch } from "./store/redux/store";
import { microDataSlice } from "./store/redux/index.ts";
// URL监测和重定向功能
// const checkAndRedirectHashRoute = () => {
//   const currentUrl = window.location.href;

//   // 检查是否包含hash路由模式: #/login?h5Emo=%2F
//   const hashRoutePattern = /#\/[^?]*\?h5Emo=/;

//   if (hashRoutePattern.test(currentUrl)) {
//     // 提取hash部分和query参数
//     const hashIndex = currentUrl.indexOf("#");
//     const queryIndex = currentUrl.indexOf("?");

//     if (hashIndex !== -1 && queryIndex !== -1) {
//       // 获取hash路径部分（去掉#）
//       const hashPath = currentUrl.substring(hashIndex + 1, queryIndex);
//       // 获取query参数部分
//       const queryParams = currentUrl.substring(queryIndex);

//       // 构建新的URL：移除hash，将hash路径作为query参数
//       const newUrl = currentUrl.substring(0, hashIndex) + queryParams;

//       console.log("检测到hash路由，重定向到:", newUrl);

//       // 使用replace避免在浏览器历史中留下记录
//       window.location.replace(newUrl);
//       return true;
//     }
//   }

//   return false;
// };

microApp.preFetch(
  microConfig
    .filter((item) => item.microPath)
    .map((item) => ({
      name: item.name,
      url: item.path,
      iframe: item.isVite,
    }))
);

microApp.addDataListener(
  "h5Emo",
  ({ path = "", app, type }: { path: string; app: string; type: string }) => {
    switch (type) {
      case "switchApp": {
        console.log(`主应用跳转到${app}`);
        // window.location.href = `/${app}?d=${path}`;
        window.location.replace(`${window.location.origin}/${app}?d=${path}`);
      }
    }
    return true;
  }
);
microApp.addDataListener(
  "meditation",
  ({ path = "", app, type }: { path: string; app: string; type: string }) => {
    switch (type) {
      case "switchApp": {
        console.log(`主应用跳转到${app}`);
        window.location.href = `${window.location.origin}/${app}?d=${path}`;
      }
    }
    return true;
  }
);
microApp.start({
  // fetch(url, option) {
  //   return window.fetch(url, option).then((res) => {
  //     return res.text().then((text) => {
  //       console.log(text, "Text");
  //       return text;
  //     });
  //   });
  // },
});

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // // 在应用启动时检查并重定向hash路由
    // if (checkAndRedirectHashRoute()) {
    //   return; // 如果发生了重定向，不继续执行后续逻辑
    // }
    let currentApp = microApp.getActiveApps({
      excludeHiddenApp: true,
      excludePreRender: true,
    });

    if (!currentApp?.length) {
      const { pathname } = window.location;
      currentApp = pathname.replace(/^\//, "")?.split("/");
    }

    dispatch(microDataSlice.actions.setMicro(currentApp[0] || ""));
  }, [dispatch]);

  return <RouterProvider router={router} />;
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>
);
